/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
// react library for routing
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { AppAuthProvider } from "./auth/AuthProvider.jsx";

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-datetime/css/react-datetime.css";
// plugins styles downloaded
import "./assets/vendor/fullcalendar/dist/fullcalendar.min.css";
import "./assets/vendor/sweetalert2/dist/sweetalert2.min.css";
import "./assets/vendor/select2/dist/css/select2.min.css";
import "./assets/vendor/quill/dist/quill.core.css";
import "./assets/vendor/nucleo/css/nucleo.css";
import "./assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
// core ./styles
import "./assets/css/argon-dashboard-pro-react.css";

import AdminLayout from "./layouts/Admin.jsx";
import AuthLayout from "./layouts/Auth.jsx";
import PrivateComponent from "./PrivateComponent.jsx";
import { AdminStateProvider } from "./providers/AdminStateProvider.jsx";
import { env } from "./env.js";
import analytics from "./utils/analytics";

const GA_ANALITYCS_ID = env.REACT_APP_GA_TRACKING_ID;

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <PrivateComponent>
        <Component {...props} />
      </PrivateComponent>
    )}
  />
)


if (GA_ANALITYCS_ID) {
  analytics.initialize(GA_ANALITYCS_ID);
}

ReactDOM.render(
  <AppAuthProvider>
    <BrowserRouter>
      <AdminStateProvider>
        <Switch>
          <Route path="/auth" component={props => <AuthLayout {...props} />} />
          <PrivateRoute path="/admin" component={AdminLayout} />
          <Redirect from="*" to="/auth" />
        </Switch>
      </AdminStateProvider>
    </BrowserRouter>
  </AppAuthProvider>,
  document.getElementById("root")
);
